import store from '@/store'
import { Component, Vue, Watch } from '@/common';

@Component({})
export default class ResizeHandler extends Vue {

  @Watch('$route')
  watchRoute(newVal,oldVal) {
    window.document.title=newVal.meta.title;
  }

  beforeMount() {
    window.addEventListener('resize', this.resizeHandler)
  }
  mounted() {

  }

  resizeHandler() {
    // console.log('ToggleDevice');
  }
}
